/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TopicsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABCklEQVR4nGNgGDYgICDSzM8//IBfQMRXv4CI/6Rg34Dwp34BER2hoaFsWA339Q1V8fWP+EyqwX6YuAO7Bf4R7WCX+Ecs9/Pz4/ULDIsmxwLfgPCn2C0ICJ8NUuDjH14CFWIk1xcM2IC/f3g4FYLnP04L6uvrmXwDwjfSzAJsAF2jv3+4FTZ1PgGRNlSxwCcg0gabOn//cFuqWOBH6yDyG42DIRMHfuAiJ/yxT0C4J80s8AOXSxGPSLAg/ArRXkfSS0jRPyRLfhBruL9/uCwkmCI+4LfAP/wWqT4AG+4fvh2sxz98JX4LAiOyKYjkN4GB0TKEHMToFxiR5xsQcZ94w8M/glxOjOFDBwAAh6oFwpgDWd8AAAAASUVORK5CYII=)
 */
export const TopicsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M3.11 8H6v10.82c0 .86.37 1.68 1 2.27.46.43 1.02.71 1.63.84A1 1 0 0 0 9 22h10a4 4 0 0 0 4-4v-1a2 2 0 0 0-2-2h-1V5a3 3 0 0 0-3-3H4.67c-.87 0-1.7.32-2.34.9-.63.6-1 1.42-1 2.28 0 .71.3 1.35.52 1.75a5.35 5.35 0 0 0 .48.7l.01.01h.01L3.11 7l-.76.65a1 1 0 0 0 .76.35Zm1.56-4c-.38 0-.72.14-.97.37-.24.23-.37.52-.37.81a1.69 1.69 0 0 0 .3.82H6v-.83c0-.29-.13-.58-.37-.8C5.4 4.14 5.04 4 4.67 4Zm5 13a3.58 3.58 0 0 1 0 3H19a2 2 0 0 0 2-2v-1H9.66ZM3.86 6.35ZM11 8a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2h-5Zm-1 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
